
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Collapse from '@/components/paragraphColl.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Collapse, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      spinning: true,
      str: ''
    })
    watch(
      () => (props.pageSourceData || {}).BusinessReview,
      (val: any) => {
        pageData.str = val
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
